module.exports = __webpack_public_path__ + "img/background_1.524df190.png";